import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  header_actions: {
    color: Colors.APP_COLOR_HIGHLIGHT(),
    background: 'white',
    border: '1px solid white',
    marginLeft: '.5rem',
    '&:hover': {
      background: 'white',
    },
  },
  stickyBarTransition: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarClose: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  sticky_bar: {
    position: 'fixed',
    // top: 64,
    // overflow: 'auto',
    zIndex: 1190,
    // [theme.breakpoints.down('sm')]: {
    //   top: 56,
    // },
  },
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    width: '100%',
    marginBottom: 10,
    elevation: 10,
  },
  back_button: {
    color: 'white',
    marginRight: '2rem',
    padding: '0px',
  },
  subtitles: {
    padding: '1rem 12px',
  },
  subtitle2: {
    marginTop: '.5rem',
    fontWeight: 'normal',
    marginBottom: '.5rem',
  },
  card: {
    background: 'white',
    borderRadius: '.5rem',
    padding: '2rem 1rem',
    border: '1px solid lightgray',
  },
}));

export default useStyles;
